import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const Testimonials = ({ onOpenModal }) => {
  const youtubeVideos = [
    "iQYgQOlO8rc", "XagCkSdT65k", "QVP91lJeLbk", "zSlUDIdx098", 
    "eDtrgRkSqWk", "kzlgcQa4z9c", "DDheW2eaD_g", "tiHjb9z5mSU", 
    "yx_uiUzwix8", "KTZUqXzx3ho", "tkPwIGt-hck", "iT4jGJOGbZw", 
    "Jru_9NiD4Vg", "y10fUxXLxwk"
  ];

  const igReels = [
    "DSzZgZrgHSY", "DM0X3iTMs63", "DMsryJisuf7", "DMkU0REMqe4", 
    "DMdMsu0Mdqq", "DMU1JbIMcpb", "DMN2Y2bsf3l", "DLDE587skIv", "DJq4oPYMI8K"
  ];

  useEffect(() => {
    // Carica lo script di Instagram se non è già presente
    const script = document.createElement('script');
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Pulizia opzionale (nella pratica SPA spesso si lascia caricato)
    };
  }, []);

  useEffect(() => {
    // Forza il processamento degli embed di Instagram ad ogni render del componente
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [igReels]);

  return (
    <section id="testimonials" className="py-24 bg-black-pure relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10 max-w-6xl">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-7xl font-black text-white mb-6 uppercase tracking-tighter">
            CASI DI <span className="text-orange-500 italic">SUCCESSO</span>
          </h2>
          <p className="text-slate-400 font-bold uppercase tracking-widest text-sm">
            Risultati reali ottenuti dai nostri studenti
          </p>
          <div className="w-24 h-1 bg-orange-600 mx-auto mt-6 rounded-full"></div>
        </div>

        {/* YouTube Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {youtubeVideos.map((id, index) => (
            <motion.div 
              key={`yt-${id}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (index % 4) * 0.1 }}
              className="relative w-full overflow-hidden rounded-[2rem] border-2 border-white/10 shadow-2xl bg-black aspect-video group hover:border-orange-500/50 transition-colors"
            >
              <iframe 
                src={`https://www.youtube.com/embed/${id}`}
                title={`YouTube testimonial ${index + 1}`}
                className="absolute top-0 left-0 w-full h-full border-0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </motion.div>
          ))}
        </div>

        {/* Instagram Reels Grid */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-2xl font-black text-white uppercase tracking-tight">
              HIGHLIGHTS DAI <span className="text-orange-500 italic">SOCIAL</span>
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {igReels.map((id, index) => (
              <motion.div 
                key={`ig-${id}`}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: (index % 3) * 0.1 }}
                className="w-full flex justify-center"
              >
                <div className="w-full max-w-[400px] rounded-3xl overflow-hidden border border-white/10 bg-white/5">
                  <blockquote 
                    className="instagram-media" 
                    data-instgrm-permalink={`https://www.instagram.com/reel/${id}/`} 
                    data-instgrm-version="14" 
                    style={{ background: '#000', border: '0', margin: '0', padding: '0', width: '100% !important' }}
                  ></blockquote>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="flex justify-center mt-16">
          <button 
            onClick={onOpenModal}
            className="btn-premium text-white px-12 py-5 rounded-2xl font-black text-xl flex items-center space-x-3 shadow-[0_0_50px_rgba(249,115,22,0.3)] hover:shadow-[0_0_70px_rgba(249,115,22,0.5)] transition-all duration-300"
          >
            <span>Voglio questi Risultati</span>
            <SafeIcon icon={FiArrowRight} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;